import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export type DiscoverAutoplayPreference = 'on' | 'off'

export const useFeedPreferencesStore = defineStore(
  'feedPreferences',
  () => {
    const discoverAutoplay = ref<DiscoverAutoplayPreference>('on')
    const isDiscoverAutoplayEnabled = computed(() => discoverAutoplay.value === 'on')

    function setDiscoverAutoplay(value: DiscoverAutoplayPreference) {
      discoverAutoplay.value = value
    }

    return {
      discoverAutoplay,
      isDiscoverAutoplayEnabled,
      setDiscoverAutoplay,
    }
  },
  {
    persist: {
      key: 'feed-preferences',
      storage: localStorage,
      paths: ['discoverAutoplay'],
    },
  },
)
